import { render, staticRenderFns } from "./fccDificuldade.vue?vue&type=template&id=59091d3e"
import script from "./fccDificuldade.vue?vue&type=script&lang=js"
export * from "./fccDificuldade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports